// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataxoksol } from "../../../icons/full/build/icon-stataxoksol.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataxoksolIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataxoksol.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataxoksolIcon.displayName = 'StataxoksolIcon';
}

export default StataxoksolIcon;